import React from 'react';
import { ActivityCalendar, type Activity } from 'react-activity-calendar';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/admin/components/ui/tooltip';

interface ActivityHeatmapProps {
  data: Array<{ date: string; value: number }>;
  blockSize?: number;
}

export const ActivityHeatmap: React.FC<ActivityHeatmapProps> = ({
  data,
  blockSize = 10,
}) => {
  // transform input data to map for O(1) lookup
  const dataMap = new Map(data.map(d => [d.date, d.value]));

  // Generate data for the last 16 weeks (approx 4 months)
  const calendarData: Activity[] = [];
  const today = new Date();
  const daysToShow = 16 * 7; // 16 weeks

  for (let i = daysToShow; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    const dateStr = d.toISOString().split('T')[0];
    const value = dataMap.get(dateStr) || 0;

    calendarData.push({
      date: dateStr,
      count: value,
      level: value === 0 ? 0 : Math.min(4, Math.ceil(value / 2)),
    });
  }

  return (
    <div className="w-full flex justify-center">
      <ActivityCalendar
        data={calendarData}
        theme={{
          light: ['#f1f5f9', '#cbd5e1', '#94a3b8', '#64748b', '#475569'],
          dark: ['#f1f5f9', '#cbd5e1', '#94a3b8', '#64748b', '#475569'],
        }}
        showWeekdayLabels
        blockSize={blockSize}
        blockMargin={4}
        fontSize={12}
        renderBlock={(block: React.ReactElement, activity: Activity) => (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger asChild>
                {React.cloneElement(block, {
                  style: { cursor: 'default' },
                } as any)}
              </TooltipTrigger>
              <TooltipContent>
                {activity.count} experiments on {activity.date}
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      />
    </div>
  );
};
